import { createContext, useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { getButtonsDef,
        getTitleByType } from "./helpers/helperModalContext";
import { useTranslation } from "react-i18next";

const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {

    const { t } = useTranslation();
    // Стан діалогу
    const [ show, setShow ] = useState(false);
    const [ buttons, setButtons ] = useState(getButtonsDef(t));
    const [ title, setTitle ] = useState(getTitleByType());
    const [ text, setText ] = useState(null);
    const [ refFirstFocus, setRefFirstFocus ] = useState(null);
    const [ size, setSize ] = useState('');
 
    // Закриття діалогу
    const hideDlg = () => {
        setShow(false)
    }

    /**
     * діалогу (передається контекстом)
     * @param {object} params
     * @param {Array of object} params.buttons = []
     * 
     * @param {string}  params.buttons[].title
     * @param {string}  params.buttons[].variant
     * @param {string}  params.buttons[].handleClick
     * 
     * @param {string}  params.type                     Тип ділогу('confirm', 'errror', 'info')
     * @param {string}  params.title                    Заголовок (кастумний)
     * @param {string}  params.text                     Текст діалогу
     * @param {bool}    params.sizeLg                   Признак широкого формату діалогу 
     * @param {ref}     params.refFirstFocus            Елемент який фокусується при показі діалогу
     *  */ 
    const showDlg = (params) => {
        if (params === false) return hideDlg();
        setTitle(params?.title||getTitleByType(params?.type));
        setText(params?.text);
        setButtons(params?.buttons||getButtonsDef(t));
        setRefFirstFocus(params?.refFirstFocus);
        setShow(true);
        setSize((params?.sizeLg)?'lg':'')
    }

    const handleShow = () => {
        if (refFirstFocus) refFirstFocus?.current?.focus();
    } 
        
    return ( 
        <ModalContext.Provider value={{showDlg, hideDlg}}>
            {children}

            <Modal show={show} onHide={hideDlg}
                onShow={handleShow}
                size={size}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{text}</Modal.Body>
                <Modal.Footer>
                    {buttons.map((button, index) => {
                        return (
                            <Button key={index}
                                className="min100px"
                                variant={button.variant||'secondary'} 
                                onClick={button.handleClick||hideDlg}>{button.title}</Button>
                        )
                    })}
                    
                </Modal.Footer>
            </Modal>
        </ModalContext.Provider>
    );
};
